import { BodyLarge, FlexAlignCenter } from '../../../../../components/Elements';
import strings from '../../../../../strings/strings.json';
import styled from 'styled-components';
import ArrowRightIcon from 'assets/icons/controls/ArrowRightIcon';
import { breakpoints, sizes } from 'theme';
import Button from 'components/buttons/Button';

type StartQuestionnaireCardProps = {
    totalQuestions: number;
    startQuestionnaire: () => void;
    questionnaireTitle: string;
};
export default function StartQuestionnaireCard({
    totalQuestions,
    startQuestionnaire,
    questionnaireTitle,
}: StartQuestionnaireCardProps): JSX.Element {
    return (
        <>
            <StartButtonContainer>
                <BodyLarge $bold>
                    {totalQuestions} {strings.questionnairePage.questionsNumberLabel}
                </BodyLarge>

                <Button
                    title={strings.questionnairePage.startQuestionnaireButton}
                    aria={`${strings.questionnairePage.startQuestionnaireButtonAria}: ${questionnaireTitle}`}
                    onClick={startQuestionnaire}
                    icon={<ArrowRightIcon />}
                    iconOnRight
                    autoFocus
                    colour="PRIMARY"
                />
            </StartButtonContainer>
        </>
    );
}

const StartButtonContainer = styled(FlexAlignCenter)`
    justify-content: space-between;
    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        align-items: unset;
        gap: ${sizes.spacingMd};
    }
`;
